import { fnv1a } from "./scoring";
import type { SelvesState } from "./types";

export const ENGINE_VERSION = "mld-2";

export const ENGINE_LABEL = `Multiverse Life Dossier · engine ${ENGINE_VERSION}`;

export const LIFE_CHAPTERS: { id: string; title: string; blurb: string }[] = [
  {
    id: "identity",
    title: "Identity & Biography",
    blurb: "A comprehensive account of name, chronological age, temperament, and lived personal history.",
  },
  {
    id: "work",
    title: "Work & Expertise",
    blurb: "Professional specialization, career evolution, daily responsibilities, and physical workplace.",
  },
  {
    id: "standing",
    title: "Standing & Influence",
    blurb: "Economic bracket, societal reputation, institutional prestige, and reach of influence.",
  },
  {
    id: "home",
    title: "Home & Daily Life",
    blurb: "Living quarters, immediate environment, material possessions, and daily domestic cadence.",
  },
  {
    id: "people",
    title: "People & Connections",
    blurb: "Family bonds, key partnerships, close friendships, and surrounding social networks.",
  },
  {
    id: "formative",
    title: "Formative Years",
    blurb: "Childhood circumstances, foundational schooling, early decisions, and critical turning points.",
  },
  {
    id: "society",
    title: "Society & Institutions",
    blurb: "Legal structures, governing bodies, cultural norms, and prevailing civic expectations.",
  },
  {
    id: "world",
    title: "World & Technology",
    blurb: "Scientific paradigms, technological infrastructure, physical geography, and planetary state.",
  },
  {
    id: "differs",
    title: "How This World Differs from Earth",
    blurb: "Direct contrasts between this reality's physical and social paradigms and baseline Earth.",
  },
  {
    id: "earth",
    title: "Compared With My Earth Life",
    blurb: "Systematic domain-by-domain divergence between this alternate trajectory and contemporary Earth.",
  },
  {
    id: "day",
    title: "A Day in This Life",
    blurb: "An hour-by-hour chronicle through a typical day from early dawn until evening rest.",
  },
  {
    id: "futures",
    title: "Three Possible Futures",
    blurb: "Branching forward trajectories exploring natural continuation, ambitious expansion, and wildcard turns.",
  },
  {
    id: "timeline",
    title: "Life Timeline",
    blurb: "Key chronological milestones and pivotal life events from birth into the approaching future.",
  },
];

export function variationIdFor(state: SelvesState): string {
  const hash = fnv1a(state.variants.join("-")) >>> 0;
  return `V-${hash.toString(16).toUpperCase().padStart(8, "0").slice(0, 6)}`;
}
